import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { useSubmitForm } from '../FormComponent/useSubmitForm'
import { useGetDataForm } from '../DataFormComponent/useGetDataForm'
import { SheetDescription, SheetHeader, SheetTitle } from '@/components/shadcn/sheet'
import { ScrollArea } from '@/components/shadcn/scroll-area'
import { FormContentV2 } from '../FormComponent'
import { toast } from 'sonner'
import clsx from 'clsx'
import { useCallback } from 'react'
import { DataTableV2DataRow } from '../DataTableV2/types'
import { FormData } from '../DataFormComponent/types'
import { JsonFormPropertyV2 } from '../FormComponent/types'
import { transformTitleValueObjectsToValues, transformValuesToTitleValueObjects } from '../DataTableV2/utils'

type SheetFormData = Record<string, unknown> & {
  id?: string | number
}

export function SheetFormComponent({
  contentId,
  isOpen,
  setIsOpen,
  formData,
  actionId: _actionId,
  onSubmitOverride,
}: {
  contentId: string
  isOpen?: boolean
  setIsOpen: (isOpen: boolean) => void
  formData?: SheetFormData
  actionId?: string
  onSubmitOverride?: (groupId: string, data: FormData, formProperties: JsonFormPropertyV2[]) => void
}) {
  const { tileFilterSelections } = useTileFilters()
  const hasRowId = typeof formData?.id === 'string' || typeof formData?.id === 'number'
  const payload = formData
    ? {
        formData: hasRowId
          ? transformTitleValueObjectsToValues(formData as DataTableV2DataRow)
          : (formData as Record<string, unknown>),
      }
    : undefined
  // const contentTf = formData
  //   ? [...tileFilterSelections, { formData: transFormTitleValueObjectsToValues(formData) }]
  //   : tileFilterSelections
  const {
    data: {
      uiSchema: {
        schema: { title, description, ...formSchema },
        actions: { handlerId: formHandlerId },
      },
    },
  } = useGetDataForm(
    contentId,
    tileFilterSelections,
    payload
  )
  // const eventTf = actionId ? [...tileFilterSelections, { actionId: actionId }] : tileFilterSelections
  const { mutateAsync: submitForm, isPending: isSubmitting } = useSubmitForm(formHandlerId, tileFilterSelections)

  const { properties: formProperties } = formSchema
  const submitHandler = useCallback(
    (data: FormData) => {
      if (onSubmitOverride) {
        onSubmitOverride(hasRowId ? String(formData?.id) : '', { ...formData, ...data }, formProperties)
        setIsOpen(false)
        return
      }
      submitForm({ ...formData, ...transformValuesToTitleValueObjects(data, formProperties) })
        .then((response) => {
          if (response.uiSchema.success === false) {
            toast.error(response.uiSchema.message ?? 'Something went wrong')
            return
          }
          setIsOpen(false)
        })
        .catch((error) => {
          console.error(error)
          toast.error('Something went wrong')
        })
    },
    [hasRowId, onSubmitOverride, submitForm, formData, formProperties, setIsOpen]
  )

  return (
    <>
      {title && (
        <SheetHeader className="sticky inset-0 border-b pb-5">
          <SheetTitle>{title}</SheetTitle>
          <SheetDescription>{description ?? ''}</SheetDescription>
        </SheetHeader>
      )}
      <ScrollArea className={clsx(title ? 'h-[calc(100%-77px)]' : 'h-full')}>
        <div className="pl-1 pr-6 lg:max-w-[46.75rem]">
          <FormContentV2
            schema={formSchema}
            submitHandler={submitHandler}
            isSubmitting={isSubmitting}
            resetOnOpen={isOpen}
          />
        </div>
      </ScrollArea>
    </>
  )
}
